import { Reveal, Overline } from "./Reveal";

const team = [
  {
    initials: "SJ",
    image: "/stensonJohny.jpg",
    name: "Stenson Johny",
    role: "International Enrolment & Student Recruitment",
    desc: "Previously International Enrolment Officer at Stamford International University, Thailand, and Manager of International Recruitment for SP Jain School of Global Management, covering Thailand, Cambodia and Myanmar. He brings a university-side perspective to mentoring students through their education choices.",
  },
  {
    initials: "MJ",
    image: "/ManojJose.jpg",
    name: "Manoj Jose",
    role: "Youth Training & Empowerment",
    desc: "A John Maxwell-certified trainer who has delivered hundreds of training sessions across the GCC. His work with young people focuses on self-awareness, public speaking, interview preparation and the life skills that build confidence.",
  },
  {
    initials: "RJ",
    image: "/ReshmaJerome.jpg",
    name: "Reshma Jerome",
    role: "International Student Experience & Hospitality Management",
    desc: "An MBA graduate in Finance from Assumption University, Thailand, Reshma brings firsthand experience of life as an international student, followed by several years in hospitality management. She draws on that journey to help students understand studying, living and adapting abroad.",
  },
];

export const Team = () => (
  <section
    id="team"
    data-testid="team-section"
    className="relative pt-20 lg:pt-28 pb-12 lg:pb-16 bg-[#FFFFFF]"
  >
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <Reveal>
        <Overline testid="team-overline">THE PEOPLE BEHIND MOVEMENTOR</Overline>
        <h2
          data-testid="team-heading"
          className="mt-6 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-[#111111] max-w-2xl"
        >
          Different experiences. A shared commitment to mentoring.
        </h2>
      </Reveal>

      <div className="mt-10 lg:mt-14 grid md:grid-cols-3 gap-6">
        {team.map((m, i) => (
          <Reveal key={m.initials} delay={i * 0.12}>
            <article
              data-testid={`team-member-${i}`}
              className="group h-full bg-white rounded-3xl border border-black/5 p-8 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-orange-500/10 transition-[transform,box-shadow] duration-500"
            >
              <div className="w-24 h-24 overflow-hidden rounded-2xl border border-black/5 bg-gradient-to-br from-[#FE7815] to-[#F01E1F] shadow-md">
                <img
                  src={m.image}
                  alt={m.name}
                  className="h-full w-full object-cover grayscale"
                />
              </div>
              <h3 className="mt-6 text-xl font-semibold text-[#111111]">
                {m.name}
              </h3>
              <p className="mt-1 text-xs uppercase tracking-[0.18em] font-bold text-[#FE7815]">
                {m.role}
              </p>
              <p className="mt-4 text-sm text-[#111111] leading-relaxed">
                {m.desc}
              </p>
            </article>
          </Reveal>
        ))}
      </div>

    </div>
  </section>
);
